// @ts-ignore
import React from "react";
import { NewModal } from '../uiMerge/newModal';
import Button from "../uiMerge/newButton";

type MerchantInfoModalProps = {
  visible: boolean;
  onCancel: () => void;
  involveMe?: () => void;
};

const InvolveMeModal = ({
  involveMe,
  visible,
  onCancel,
}: MerchantInfoModalProps) => {

  const handleClose = () =>{
    involveMe && involveMe()
    onCancel() 
  }
  return (
    <NewModal
      isOpen={visible}
      roundedClass="rounded-[10px]"
      colorClass="bg-black"
      widthClass="w-[329px]"
      position="center"
      onClose={onCancel}
    >
      <div className="flex flex-col items-center my-3 py-[18px] px-[18px] gap-3">
        <p className="font-extrabold text-white text-[20px]">Involve Me</p>
        
        <div className="flex justify-center">
          <p className="font-medium text-white px-3 text-[14px] text-center">
           Are you sure you don’t want to receive updates about new perks and deals from this merchant?
          </p>
        </div>
        <div className="flex justify-between w-full mt-1 gap-5">
          <Button className="w-full" onClick={onCancel} variant="outline">
         Cancel
          </Button>
          <Button  className="w-full" onClick={handleClose} variant="primary" >
             Yes
          </Button>
        </div>
      </div>
    </NewModal>
  );
};

export default InvolveMeModal;